import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector, change, FieldArray } from 'redux-form';
import cx from 'classnames';
import { Button } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';

// Component
import Image from '../WhyHostFormBlock1/Image/Image';
import CommonFormComponent from '../../../CommonField/CommonFormComponent';
import FieldArrayComponent from '../../../CommonFields/FieldArrayComponent';

// helpers
import messages from '../../../../locale/jsonMessages';
import submit from './submit';
import validate from './validate';
import { formatLocaleData } from '../../../../helpers/formatLocale';

// style
import cs from '../../../../components/commonStyle.css';
import s from './WhyHostFormBlock7.css';

class WhyHostFormBlock7 extends Component {

  constructor(props) {
    super(props);
    this.success = this.success.bind(this);
  }

  async success(file, fromServer) {
    const { change } = this.props;
    await change('image', fromServer && fromServer.file.filename);
  }


  render() {

    const { error, handleSubmit, submitting, reviewId, image, imageloader, selectedLanguage } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <div>
        <h1 className='siteAdminHeading'><FormattedMessage {...messages.WhyBecomeOwnerBlock6} /></h1>
        <form onSubmit={handleSubmit(submit)}>
          {error && <strong>{formatMessage(error)}</strong>}
          <div className="oneColumnGrid">
            <div className='siteAdminCenterContainer'>
              <div className='siteAdminDropZoneWrapper'>
                <label className={cx('commonLabelText', cs.spaceBottom3)}><FormattedMessage {...messages.imageLabel} /></label>
                <Image image={image} fieldName={"image"} loader={imageloader} />
              </div>
            </div>
            {reviewId &&
              <div className="twoColumnGrid">
                <Field
                  name="isEnable"
                  inputClass='commonSelectField'
                  component={CommonFormComponent}
                  placeholder={formatMessage(messages.status)}
                  labelText={formatMessage(messages.status)}
                >
                  <option value={true}>{formatMessage(messages.enableLabel)}</option>
                  <option value={false}>{formatMessage(messages.disableLabel)}</option>
                </Field>
              </div>}
            <div className='siteAdminCenterContainerBox'>
              <FieldArray
                name="dynamicAdminReviews"
                component={FieldArrayComponent}
                activesFields={['userName', 'reviewContent', 'language']}
                filedName="dynamicAdminReviews"
                selectedLanguage={selectedLanguage}
                isDouble
              />
            </div>
          </div>
          <div className={cx(cs.spaceTop4, 'singleBtnFlexEnd')}>
            <Button className={cx(cs.btnPrimary)} type="submit" disabled={submitting}>
              <FormattedMessage {...messages.save} />
            </Button>
          </div>
        </form>
      </div>
    );
  }

}

WhyHostFormBlock7 = reduxForm({
  form: 'WhyHostForm',
  validate
})(WhyHostFormBlock7);


const selector = formValueSelector('WhyHostForm');

const mapState = state => ({
  image: selector(state, 'image'),
  imageloader: state.loader.image,
  selectedLanguage: selector(state, 'dynamicAdminReviews'),
  activeLanguageCodes: state.runtime.isActiveLanguages.map(item => formatLocaleData(item))
});
const mapDispatch = {
  change
};

export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(WhyHostFormBlock7)));